export default "__VITE_ASSET__ec39c2ff__"